import { render, staticRenderFns } from "./WPDialog.vue?vue&type=template&id=501b8136"
import script from "./WPDialog.vue?vue&type=script&lang=ts"
export * from "./WPDialog.vue?vue&type=script&lang=ts"
import style0 from "./WPDialog.vue?vue&type=style&index=0&id=501b8136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports